import { createAction, createReducer } from '@mews/framework';
import { prefix } from './module';

const closedDialogState = { open: false };

const INITIAL_STATE = {
    printReason: closedDialogState,
};

export type DialogState = typeof INITIAL_STATE;

const OPEN_DIALOG = prefix('OPEN_DIALOG');
const CLOSE_DIALOG = prefix('CLOSE_DIALOG');

const dialogReducer = createReducer(INITIAL_STATE, {
    [OPEN_DIALOG]: (state: DialogState, name: string) => ({
        ...state,
        [name]: { open: true },
    }),
    [CLOSE_DIALOG]: (state: DialogState, name: string) => ({ ...state, [name]: { open: false } }),
});

export const openDialog = (name: string) => createAction(OPEN_DIALOG, name);
export const closeDialog = (name: string) => createAction(CLOSE_DIALOG, name);

export default dialogReducer;
